import 'css-chunksrc/client/scenes/resourceEdition/form/styles.scss';export default {
  "projectResourceEditionForm": "_projectResourceEditionForm_2m6yq_1",
  "title": "_title_2m6yq_5",
  "description": "_description_2m6yq_9",
  "profession": "_profession_2m6yq_21",
  "name": "_name_2m6yq_22",
  "section": "_section_2m6yq_32"
};